export default "__VITE_ASSET__BWsPO7tI__"